module.exports = __webpack_public_path__ + "img/blog-01.70fae66f.jpg";